var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "USA_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 54.804 31.969",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #cb001c;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #2a3560;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_236",
    "data-name": "Rectangle 236",
    width: 54.804,
    height: 31.969
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_630",
    "data-name": "Group 630"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_629",
    "data-name": "Group 629"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_235",
    "data-name": "Rectangle 235",
    className: "cls-2",
    width: 54.804,
    height: 2.447,
    transform: "translate(0 29.523)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_237",
    "data-name": "Rectangle 237",
    className: "cls-3",
    width: 54.804,
    height: 2.447,
    transform: "translate(0 27.076)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_239",
    "data-name": "Rectangle 239",
    className: "cls-2",
    width: 54.804,
    height: 2.447,
    transform: "translate(0 24.629)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    className: "cls-3",
    width: 54.804,
    height: 2.447,
    transform: "translate(0 22.183)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    className: "cls-2",
    width: 54.804,
    height: 2.447,
    transform: "translate(0 19.573)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    className: "cls-3",
    width: 54.804,
    height: 2.447,
    transform: "translate(0 17.126)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    className: "cls-2",
    width: 54.804,
    height: 2.447,
    transform: "translate(0 14.68)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    className: "cls-3",
    width: 54.804,
    height: 2.447,
    transform: "translate(0 12.233)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    className: "cls-2",
    width: 54.804,
    height: 2.447,
    transform: "translate(0 9.786)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    className: "cls-3",
    width: 54.804,
    height: 2.447,
    transform: "translate(0 7.34)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    className: "cls-2",
    width: 54.804,
    height: 2.447,
    transform: "translate(0 4.893)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    className: "cls-3",
    width: 54.804,
    height: 2.447,
    transform: "translate(0 2.447)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_259",
    "data-name": "Rectangle 259",
    className: "cls-2",
    width: 54.804,
    height: 2.447
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_261",
    "data-name": "Rectangle 261",
    className: "cls-4",
    width: 24.956,
    height: 17.126
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    className: "cls-3",
    d: "M1.779,1.2l.163.652h.652L2.1,2.179l.163.652L1.779,2.5l-.652.326.326-.652L.8,1.852h.816Z",
    transform: "translate(0.505 0.757)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    className: "cls-3",
    d: "M1.779,2.9l.163.652h.652L2.1,4.042l.163.652L1.779,4.2l-.652.489.326-.652L.8,3.552h.816Z",
    transform: "translate(0.505 1.83)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    className: "cls-3",
    d: "M1.779,4.7l.163.652h.652L2.1,5.679l.163.652L1.779,6l-.652.326.326-.652L.8,5.352h.816Z",
    transform: "translate(0.505 2.966)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    className: "cls-3",
    d: "M1.779,6.4l.163.652h.652L2.1,7.542l.163.652L1.779,7.7l-.652.489.326-.652L.8,7.052h.816Z",
    transform: "translate(0.505 4.039)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    className: "cls-3",
    d: "M1.779,8.2l.163.652h.652L2.1,9.179l.163.652L1.779,9.5l-.652.326.326-.652L.8,8.852h.816Z",
    transform: "translate(0.505 5.175)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    className: "cls-3",
    d: "M2.916,2.1l.163.652h.816l-.652.326.163.652L2.916,3.4l-.489.326.163-.652L2.1,2.752h.652Z",
    transform: "translate(1.325 1.325)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    className: "cls-3",
    d: "M2.916,3.8l.163.652h.816l-.652.489.163.652L2.916,5.1l-.489.489.163-.652L2.1,4.452h.652Z",
    transform: "translate(1.325 2.398)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    className: "cls-3",
    d: "M2.916,5.6l.163.652h.816l-.652.489.163.652L2.916,6.9l-.489.489.163-.652L2.1,6.252h.652Z",
    transform: "translate(1.325 3.534)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    className: "cls-3",
    d: "M2.916,7.4l.163.652h.816l-.652.326.163.652L2.916,8.7l-.489.326.163-.652L2.1,8.052h.652Z",
    transform: "translate(1.325 4.67)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    className: "cls-3",
    d: "M4.116,1.2l.326.652h.652L4.6,2.179l.163.652L4.116,2.5l-.489.326.163-.652L3.3,1.852h.652Z",
    transform: "translate(2.083 0.757)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    className: "cls-3",
    d: "M4.116,2.9l.326.652h.652L4.6,4.042l.163.652L4.116,4.2l-.489.489.163-.652L3.3,3.552h.652Z",
    transform: "translate(2.083 1.83)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    className: "cls-3",
    d: "M4.116,4.7l.326.652h.652L4.6,5.679l.163.652L4.116,6l-.489.326.163-.652L3.3,5.352h.652Z",
    transform: "translate(2.083 2.966)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    className: "cls-3",
    d: "M4.116,6.4l.326.652h.652L4.6,7.542l.163.652L4.116,7.7l-.489.489.163-.652L3.3,7.052h.652Z",
    transform: "translate(2.083 4.039)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    className: "cls-3",
    d: "M4.116,8.2l.326.652h.652L4.6,9.179l.163.652L4.116,9.5l-.489.326.163-.652L3.3,8.852h.652Z",
    transform: "translate(2.083 5.175)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    className: "cls-3",
    d: "M5.479,2.1l.163.652h.652L5.8,3.079l.163.652L5.479,3.4l-.652.326.326-.652L4.5,2.752h.652Z",
    transform: "translate(2.84 1.325)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    className: "cls-3",
    d: "M5.479,3.8l.163.652h.652L5.8,4.942l.163.652L5.479,5.1l-.652.489.326-.652L4.5,4.452h.652Z",
    transform: "translate(2.84 2.398)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    className: "cls-3",
    d: "M5.479,5.6l.163.652h.652L5.8,6.742l.163.652L5.479,6.9l-.652.489.326-.652L4.5,6.252h.652Z",
    transform: "translate(2.84 3.534)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    className: "cls-3",
    d: "M5.479,7.4l.163.652h.652L5.8,8.379l.163.652L5.479,8.7l-.652.326.326-.652L4.5,8.052h.652Z",
    transform: "translate(2.84 4.67)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    className: "cls-3",
    d: "M6.616,1.2l.163.652h.816l-.652.326.326.652L6.616,2.5l-.489.326.163-.652L5.8,1.852h.652Z",
    transform: "translate(3.66 0.757)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    className: "cls-3",
    d: "M6.616,2.9l.163.652h.816l-.652.489.326.652L6.616,4.2l-.489.489.163-.652L5.8,3.552h.652Z",
    transform: "translate(3.66 1.83)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    className: "cls-3",
    d: "M6.616,4.7l.163.652h.816l-.652.326.326.652L6.616,6l-.489.326.163-.652L5.8,5.352h.652Z",
    transform: "translate(3.66 2.966)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    className: "cls-3",
    d: "M6.616,6.4l.163.652h.816l-.652.489.326.652L6.616,7.7l-.489.489.163-.652L5.8,7.052h.652Z",
    transform: "translate(3.66 4.039)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    className: "cls-3",
    d: "M6.616,8.2l.163.652h.816l-.652.326.326.652L6.616,9.5l-.489.326.163-.652L5.8,8.852h.652Z",
    transform: "translate(3.66 5.175)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    className: "cls-3",
    d: "M7.816,2.1l.326.652h.652L8.3,3.079l.163.652L7.816,3.4l-.489.326.163-.652L7,2.752h.652Z",
    transform: "translate(4.418 1.325)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    className: "cls-3",
    d: "M7.816,3.8l.326.652h.652L8.3,4.942l.163.652L7.816,5.1l-.489.489.163-.652L7,4.452h.652Z",
    transform: "translate(4.418 2.398)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    className: "cls-3",
    d: "M7.816,5.6l.326.652h.652L8.3,6.742l.163.652L7.816,6.9l-.489.489.163-.652L7,6.252h.652Z",
    transform: "translate(4.418 3.534)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    className: "cls-3",
    d: "M7.816,7.4l.326.652h.652L8.3,8.379l.163.652L7.816,8.7l-.489.326.163-.652L7,8.052h.652Z",
    transform: "translate(4.418 4.67)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    className: "cls-3",
    d: "M9.179,1.2l.163.652h.652L9.5,2.179l.163.652L9.179,2.5l-.652.326.326-.652L8.2,1.852h.816Z",
    transform: "translate(5.175 0.757)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    className: "cls-3",
    d: "M9.179,2.9l.163.652h.652L9.5,4.042l.163.652L9.179,4.2l-.652.489.326-.652L8.2,3.552h.816Z",
    transform: "translate(5.175 1.83)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_608",
    "data-name": "Group 608",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    className: "cls-3",
    d: "M9.179,4.7l.163.652h.652L9.5,5.679l.163.652L9.179,6l-.652.326.326-.652L8.2,5.352h.816Z",
    transform: "translate(5.175 2.966)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    className: "cls-3",
    d: "M9.179,6.4l.163.652h.652L9.5,7.542l.163.652L9.179,7.7l-.652.489.326-.652L8.2,7.052h.816Z",
    transform: "translate(5.175 4.039)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    className: "cls-3",
    d: "M9.179,8.2l.163.652h.652L9.5,9.179l.163.652L9.179,9.5l-.652.326.326-.652L8.2,8.852h.816Z",
    transform: "translate(5.175 5.175)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    className: "cls-3",
    d: "M10.316,2.1l.163.652h.816l-.652.326.163.652L10.316,3.4l-.489.326.163-.652L9.5,2.752h.652Z",
    transform: "translate(5.995 1.325)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    className: "cls-3",
    d: "M10.316,3.8l.163.652h.816l-.652.489.163.652L10.316,5.1l-.489.489.163-.652L9.5,4.452h.652Z",
    transform: "translate(5.995 2.398)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    className: "cls-3",
    d: "M10.316,5.6l.163.652h.816l-.652.489.163.652L10.316,6.9l-.489.489.163-.652L9.5,6.252h.652Z",
    transform: "translate(5.995 3.534)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    className: "cls-3",
    d: "M10.316,7.4l.163.652h.816l-.652.326.163.652L10.316,8.7l-.489.326.163-.652L9.5,8.052h.652Z",
    transform: "translate(5.995 4.67)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    className: "cls-3",
    d: "M11.679,1.2l.163.652h.652L12,2.179l.163.652L11.679,2.5l-.652.326.163-.652L10.7,1.852h.652Z",
    transform: "translate(6.753 0.757)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    className: "cls-3",
    d: "M11.679,2.9l.163.652h.652L12,4.042l.163.652L11.679,4.2l-.652.489.163-.652L10.7,3.552h.652Z",
    transform: "translate(6.753 1.83)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_617",
    "data-name": "Group 617",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    className: "cls-3",
    d: "M11.679,4.7l.163.652h.652L12,5.679l.163.652L11.679,6l-.652.326.163-.652L10.7,5.352h.652Z",
    transform: "translate(6.753 2.966)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_618",
    "data-name": "Group 618",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    className: "cls-3",
    d: "M11.679,6.4l.163.652h.652L12,7.542l.163.652L11.679,7.7l-.652.489.163-.652L10.7,7.052h.652Z",
    transform: "translate(6.753 4.039)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    className: "cls-3",
    d: "M11.679,8.2l.163.652h.652L12,9.179l.163.652L11.679,9.5l-.652.326.163-.652L10.7,8.852h.652Z",
    transform: "translate(6.753 5.175)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_620",
    "data-name": "Group 620",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    className: "cls-3",
    d: "M12.879,2.1l.163.652h.652l-.489.326.163.652L12.879,3.4l-.652.326.326-.652L11.9,2.752h.652Z",
    transform: "translate(7.51 1.325)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_621",
    "data-name": "Group 621",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    className: "cls-3",
    d: "M12.879,3.8l.163.652h.652l-.489.489.163.652L12.879,5.1l-.652.489.326-.652L11.9,4.452h.652Z",
    transform: "translate(7.51 2.398)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_622",
    "data-name": "Group 622",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    className: "cls-3",
    d: "M12.879,5.6l.163.652h.652l-.489.489.163.652L12.879,6.9l-.652.489.326-.652L11.9,6.252h.652Z",
    transform: "translate(7.51 3.534)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    className: "cls-3",
    d: "M12.879,7.4l.163.652h.652l-.489.326.163.652L12.879,8.7l-.652.326.326-.652L11.9,8.052h.652Z",
    transform: "translate(7.51 4.67)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_624",
    "data-name": "Group 624",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    className: "cls-3",
    d: "M14.016,1.2l.163.652h.816l-.652.326.326.652L14.016,2.5l-.489.326.163-.652L13.2,1.852h.652Z",
    transform: "translate(8.33 0.757)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    className: "cls-3",
    d: "M14.016,2.9l.163.652h.816l-.652.489.326.652L14.016,4.2l-.489.489.163-.652L13.2,3.552h.652Z",
    transform: "translate(8.33 1.83)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_626",
    "data-name": "Group 626",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    className: "cls-3",
    d: "M14.016,4.7l.163.652h.816l-.652.326.326.652L14.016,6l-.489.326.163-.652L13.2,5.352h.652Z",
    transform: "translate(8.33 2.966)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    className: "cls-3",
    d: "M14.016,6.4l.163.652h.816l-.652.489.326.652L14.016,7.7l-.489.489.163-.652L13.2,7.052h.652Z",
    transform: "translate(8.33 4.039)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_628",
    "data-name": "Group 628",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    className: "cls-3",
    d: "M14.016,8.2l.163.652h.816l-.652.326.326.652L14.016,9.5l-.489.326.163-.652L13.2,8.852h.652Z",
    transform: "translate(8.33 5.175)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/us.f026e997589ee3c500a65c9be666fb45.svg";
export { ForwardRef as ReactComponent };